<template>
  <div id="home" class="main">
    <!-- 头部 -->
    <Header index="5"></Header>
    <div class="content">
       <!--[if lte IE 9]>
            <p class="browserupgrade">You are using an <strong>outdated</strong> browser. Please <a href="https://browsehappy.com/">upgrade your browser</a> to improve your experience and security.</p>
        <![endif]-->

        <!-- Add your site or application content here -->  

        <!-- prealoder area start -->
        <!-- <div id="loading">
            <div id="loading-center">
                <div id="loading-center-absolute">
                <div class="object" id="first_object"></div>
                <div class="object" id="second_object"></div>
                <div class="object" id="third_object"></div>
                </div>
            </div>      
        </div> -->
        <!-- prealoder area end -->

     
        <div class="body-overlay transition-3"></div>
        <!-- extra info area end -->

        <main>
           
            <!-- slider area end -->

            <!-- page title area start -->
            <section class="page__title p-relative d-flex align-items-center"  :style="'background-image:url(' + allurl + banner + ')'">
                <div class="container">
                    <div class="row">
                        <div class="col-xl-12">
                            <div class="page__title-inner text-center">
                                <h1>Services</h1>
                                <div class="page__title-breadcrumb">                                 
                                    <nav aria-label="breadcrumb">
                                    <ol class="breadcrumb justify-content-center">
                                        <li class="breadcrumb-item"><a href="index.html">Home</a></li>
                                        <li class="breadcrumb-item active" aria-current="page"> Our Services</li> 
                                    </ol>
                                    </nav>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <!-- page title area end -->

           <!-- contact area start -->
           <section class="contact__area pb-100 pt-55">
               
                <div class="container">
                    <div class="text-left">
                         <h3 style="margin:20px 0">CLICK & COLLECT</h3>
                         <p style="margin:20px 0">Shop online and then collect your order in-store with our Click & Collect service in Melbourne, Victoria, Australia.</p>
                         <h4 style="margin:20px 0">Available at stores listed below:</h4>
                    </div>
                   
                    <div class="row">
                        
                       
                       <div class="col-xl-6 col-lg-6" v-for="(item,index) in addressinfo" :key="index">
                            <div class="contact__info text-left">
                               <p style="margin:20px 0;font-size:18px">- {{item.title}}:</p>
                                <ul class="mb-55 text-left" >
                                    <li class="d-flex mb-25">
                                        <div class="contact__info-icon mr-20">
                                            <i class="fa fa-map-marker"></i>
                                        </div>
                                        <div class="contact__info-content">
                                            <h6>Address:</h6>
                                            <span>{{item.address}}</span>
                                        </div>
                                    </li>
                                    <li class="d-flex mb-25">
                                        <div class="contact__info-icon mr-20">
                                            <i class="fa fa-envelope-open-o"></i>
                                        </div>
                                        <div class="contact__info-content">
                                            <h6>Store Hours:</h6>
                                            <span>{{item.date_str}}</span>
                                        </div>
                                    </li>
                                  
                                </ul>
                              
                                
                            </div>
                        </div>
                    </div>
                    <div class="text-left">
                        <p>Order is usually available for pickup within 2-5 business days in your selected store if the item need to be reservedYou will receive a collection notification email or SMS when your order is ready for pickup in store.</p>
                    </div>
                    <div class="text-left">
                         <h3 style="margin:20px 0">EXCHANGE & RETURN POLICY</h3>
                         <div  style="margin:20px 0;border:1px solid #ccc;padding:20px;">
                             <p>lf you notice anything in your order is damaged, please take those products and your purchase receipt/tax invoiceto the store you put in the order.</p>
                            <p >Any order that is final sale, clearance or out of stock are excluded from our return policy.</p>
                            <p>All our products have a 6-month guarantee from faults and defects caused in the manufacturing and delivery process. Please note, damage caused by misuse and negligent use will void your warranty.</p>
                            
                         </div>
                         
                    </div>
                </div>
            </section>
             
            <!-- contact area end -->

             <!-- page title area start -->
           
            <!-- page title area end -->

            <!-- shop area start -->
           
            <!-- shop area end -->
            <!-- banner area start -->
           
            <!-- banner area end -->

            <!-- sale off area start -->
            
            <!-- sale off area end -->

            <!-- client slider area start -->
            
            <!-- client slider area end -->
         
            <!-- blog area start -->
            
            <!-- blog area end -->
 
            <!-- subscribe area start -->
            
            <!-- subscribe area end -->

            <!-- shop modal start -->
            <!-- Modal -->
            
                   
            <!-- shop modal end -->
        </main>

        
    </div>
    <!-- 底部 -->
    <Footer></Footer>
  </div>
</template>

<script>
import Footer from "../../components/footer.vue";
import Header from "../../components/header.vue";
import { getmessages,getservice } from "@/api/index/index";
export default {
  components: { Header, Footer },
  name: "home",
  data() { 
    return {
      currentIndex: "",
      teacherIndex: '',
      ishove:true,
      menuctive:10,
      activeBtn: 2,
      clickIndex: 0,
      banner:'',
      lanmuhe:'',
      addressinfo:[],
    //   <span>New product &nbsp;|&nbsp; </span>
    //                                         <span>Discount |&nbsp; </span>
    //                                         <span>Rxpenditures </span>
     
      value:'',
      leftIcon: require("../../assets/left.png"),
      rightIcon: require("../../assets/right-active.png"),

    };

  },
  mounted () {
    // let video = document.getElementsByClassName('video')
    // video.play()
    // 滚动条的获取
    this.getinfo()   
   
  
  },
  created(){
    //   console.log('滚动高度', window.pageYOffset)  
  },
  methods: {
    getinfo(){
        getservice().then((res)=>{
            this.addressinfo=res.list
            this.banner=res.banner[0].image
        })    
    },
    
    addchoose(code){
        this.menuctive = code;
    },
   
    changestyle(index) {
      this.currentIndex = index;
    },
    viewnews(id) {
            // this.$router.push({ name: "newsview" });
            this.$router.push({ name: "productview", query: { id } });
    },
    originstyle() {
      this.currentIndex = "";
    },
    clicktap(index) {
      this.clickIndex = index;
    },
    arrowClick(val) {
      if (val === "right") {
        this.$refs.cardShow.next();
        console.log(val)
        this.activeBtn = 2;
        this.rightIcon = require("../../assets/right-active.png");
        this.leftIcon = require("../../assets/left.png");
      } else {
        this.$refs.cardShow.prev();
        console.log(val)
        this.activeBtn = 1;
        this.leftIcon = require("../../assets/left-active.png");
        this.rightIcon = require("../../assets/right.png");
      }
    },
    changehandle (currentIndex,originIndex) {
      console.log(currentIndex,originIndex)
    },
    // 移入事件
    delHandleMouseEnter(index) {
        this.teacherIndex = index
    },
    // 移出
    delHandleMouseleave(){ 
        this.teacherIndex = ''
    }
  }
};
</script>

<style scoped lang='less'>
    .banner__area{z-index: 100;}
    .owl-carousel{display: flex;    flex-wrap: wrap;}
    .product__area .product__thumb a{display: block;}
    .col-xl-20{width:20%}
    // .col-lg-20{width:20%}
     .col-md-20{width:20%}
     .col-xs-6{width:50%}
    @media (min-width: 768px){
         .col-md-20 {
            -ms-flex: 0 0 20%;
            -webkit-box-flex: 0;
            flex: 0 0 20%;
            max-width: 20%;
        }
       
    }
    @media (min-width: 990px){
         .col-md-20 {
            -ms-flex: 0 0 20%;
            -webkit-box-flex: 0;
            flex: 0 0 20%;
            max-width: 20%;
        }
        .col-lg-20{-ms-flex: 0 0 20%;
            -webkit-box-flex: 0;
            flex: 0 0 20%;
            max-width: 20%;}
       .col-xl-20 {
            -ms-flex: 0 0 20%;
            -webkit-box-flex: 0;
            flex: 0 0 20%;
            max-width: 20%;
         }
    }

 

        //  .col-xl-20
    .sale__item a{display: block;}
    .banner__item{padding:10px;width:100%;background:#ccc;text-align: left;}
    .link-btn{border:2px solid #bc8246;border-radius: 10px;padding:1px 2px;text-transform: none;}
    .show-text span{cursor: pointer;}
    .show-text b{padding:1px 3px;}
    .el-button--primary{color: #ffffff;
    background-color: #323232;
    border-color: #323232;}
    .show-text .active b{background:#bc8246;border-radius: 10px;color:#fff}
    .subscribe__form .el-input{border:1px solid #c1c1c1!important;margin-bottom:0!important}
    // .shop__header-right{width:100%}
    // .mt--95{margin-top: -150px;}
    // @import "../../assets/css/preloader.css";
    // @import "../../assets/css/bootstrap.min.css";
    // @import "../../assets/css/slick.css";
    // @import "../../assets/css/owl.carousel.min.css";
    // @import "../../assets/css/animate.min.css";
    // @import "../../assets/css/jquery.fancybox.min.css";
    // // @import "../../assets/css/fontAwesome5Pro.css";
    // // @import "../../assets/css/ionicons.min.css";
    // @import "../../assets/css/default.css";
    // @import "../../assets/css/style.css";
    // <link rel="stylesheet" href="../../assets/css/preloader.css">
        // <link rel="stylesheet" href="../../assets/css/bootstrap.min.css">
        // <link rel="stylesheet" href="../../assets/css/slick.css">
        // <link rel="stylesheet" href="../../assets/css/metisMenu.css">
        // <link rel="stylesheet" href="../../assets/css/owl.carousel.min.css">
        // <link rel="stylesheet" href="../../assets/css/animate.min.css">
        // <link rel="stylesheet" href="../../assets/css/jquery.fancybox.min.css">
        // <link rel="stylesheet" href="../../assets/css/fontAwesome5Pro.css">
        // <link rel="stylesheet" href="../../assets/css/ionicons.min.css">
        // <link rel="stylesheet" href="../../assets/css/default.css">
        // <link rel="stylesheet" href="../../assets/css/style.css">
</style>



// WEBPACK FOOTER //
// src/views/service/service.vue